// extracted by mini-css-extract-plugin
export default {"container":"TabbedView_container__+-mJb"};